import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Button from '../../components/ui/Button';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <motion.div 
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="text-9xl font-bold text-primary mb-4"
        >
          404
        </motion.div>
        
        <h1 className="text-3xl font-bold mb-4 text-gray-800 dark:text-gray-100">
          {t('notFound.title', 'Page not found')}
        </h1>
        
        <p className="text-gray-600 dark:text-gray-300 mb-8">
          {t('notFound.description', 'Oops! The page you are looking for doesn\'t exist or has been moved.')}
        </p>
        
        <Link to="/">
          <Button leftIcon={<FiArrowLeft />}>
            {t('notFound.backHome', 'Back to Home')}
          </Button>
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;